<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-mdark";
    export let hover = "group-hover:fill-mblue group-hover:stroke-mblue";
    export let strokeWidth = "0.1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 24 24"
>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2938 3.29291C19.6843 2.90237 20.3173 2.90237 20.7078 3.29291C21.0981 3.68346 21.0983 4.3165 20.7078 4.70697L13.4139 11.9999L20.7078 19.2929C21.0983 19.6834 21.0981 20.3164 20.7078 20.707C20.3173 21.0975 19.6843 21.0975 19.2938 20.707L11.9998 13.413L4.70684 20.707C4.3163 21.0975 3.68332 21.0975 3.29278 20.707C2.90251 20.3164 2.90233 19.6834 3.29278 19.2929L10.5858 11.9999L3.29278 4.70697C2.90232 4.31651 2.90249 3.68346 3.29278 3.29291C3.68332 2.90236 4.3163 2.90236 4.70684 3.29291L11.9998 10.5859L19.2938 3.29291Z" />
</svg>
